// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"624d85ae","403":"e0e00249","453":"af7c8d70"}[chunkId] + ".chunk.js";
};